import React, {Component} from 'react';
import {TimePicker} from 'antd';
import './SATimePicker.css';
import moment from 'moment';
import Time from '../../../services/Time'
import {injectIntl} from "react-intl";

class SATimePicker extends Component {

  render() {
    const {intl: {formatMessage}, mode, minuteStep, defaultOpenValue, className, error, icon, name, onChange, placeholder, type, value, ...attributes} = this.props;
    const format = "HH:mm";

    const formattedValue = (!mode || mode === 'DURATION') ? Time.durationToMoment(value) : moment(value, format)

    const errorClassName = error ? " error" : '';

    return (
      <span className={className + errorClassName}>
        <TimePicker
          minuteStep={minuteStep || 5} defaultOpenValue={moment(defaultOpenValue || '00:00', format)}
          name={name}
          placeholder={placeholder}
          value={formattedValue}
          format={format}
          onChange={onChange}
          {...attributes}
        />
        {error && (
          <div className={"txt-error"}>{formatMessage({id: error.message}, {value: error.args})}</div>
        )}
      </span>
    );
  }
}

export default injectIntl(SATimePicker);
